import React from 'react';
import { Box } from '@mui/material';

/**
 * The bar a floating panel is dragged by.
 *
 * The same one the drive chrome uses (Maestro.js:322): full width, 26px, a
 * centred grip that lightens under the pointer. Both the caption window and
 * the developer dock wear it, so moving either feels like moving the other.
 */
export default function DragBar({ label, onPointerDown, dragging = false, sx }) {
  return (
    <Box
      component="button"
      type="button"
      aria-label={label}
      onPointerDown={onPointerDown}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 26,
        p: 0,
        width: '100%',
        flexShrink: 0,
        bgcolor: '#2a2a2a',
        border: 0,
        borderBottom: '1px solid #383838',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        cursor: dragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        touchAction: 'none',
        '&:hover > span': { bgcolor: '#6a6a6a' },
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 30,
          height: 3,
          borderRadius: 2,
          bgcolor: dragging ? '#6a6a6a' : '#484848',
          transition: 'background-color 120ms',
        }}
      />
    </Box>
  );
}
